import actions from './actions';
import initialState from '../initialState';

export const applicationReducer = (state = initialState.application, action) => {
    switch (action.type) {
        case actions.SAVING_APPLICATION:
            return { ...state, saving: action.saving };
        case actions.SET_CURRENT_APPLICATION_STATE:
            return {
                ...state,
                current: { ...state.current, ...action.application },
            };
        case actions.SET_NEXT_DISABLED:
            return { ...state, nextDisabled: action.disabled };
        case actions.SET_NAV_DISABLED:
            return { ...state, navDisabled: action.disabled };
        case actions.SET_PORTFOLIO_MODAL:
            return {
                ...state,
                portfolio: { ...state.portfolio, modalOpen: action.open },
            };
        case actions.SET_PORTFOLIO_PROPERTIES:
            return {
                ...state,
                current: {
                    ...state.current,
                    portfolio: {
                        ...state.current.portfolio,
                        properties: [...action.properties],
                    },
                },
            };
        case actions.SET_VALID_PORTFOLIO_ADDRESSES:
            return {
                ...state,
                portfolio: {
                    ...state.portfolio,
                    validPropertyAddresses: [...action.properties],
                },
            };
        case actions.SET_VIEWING:
            return {
                ...state,
                current: {
                    ...state.current,
                    viewing: { ...state.viewing, ...action.viewing },
                },
            };
        case actions.SET_APPLICATION_REVIEW_MODAL:
            return {
                ...state,
                applicationReviewModal: action.state.applicationReviewModal,
            };
        case actions.VIEW_INCOMPLETE_REVIEW_MODAL:
            return {
                ...state,
                incompleteReviewModal: action.state.incompleteReviewModal,
            };
        case actions.SET_APPLICATION_SUMMARY_MODAL:
            return {
                ...state,
                applicationSummaryModal: action.state.applicationSummaryModal,
            };
        case actions.SET_APPRAISAL_MODAL:
            return { ...state, appraisalModal: action.state.appraisalModal };
        case actions.SET_DECLINE_OR_RECYCLE_MODAL:
            return {
                ...state,
                declineOrRecycleModal: action.state.declineOrRecycleModal,
            };
        case actions.SET_ROLLBACK_MODAL:
            return { ...state, rollbackModal: action.state.rollbackModal };
        case actions.SET_CONVERT_TO_LOAN_MODAL:
            return {
                ...state,
                convertToLoanModal: action.state.convertToLoanModal,
            };
        case actions.CHANGE_APP_LOANTYPE_MODAL:
            return {
                ...state,
                changeAppLoanTypeModal: action.state.changeAppLoanTypeModal,
            };
        case actions.EDIT_REVIEWER_MODAL:
            return {
                ...state,
                editReviewerModal: action.state.editReviewerModal,
            };
        case actions.RESTORE_APPLICATION_MODAL:
            return {
                ...state,
                restoreApplicationModal: action.state.restoreApplicationModal,
            };
        case actions.MOVE_PROPERTIES_MODAL:
            return {
                ...state,
                movePropertiesModal: action.state.movePropertiesModal,
            };
        case actions.AUDIT_HISTORY_MODAL:
            return {
                ...state,
                auditHistoryModal: action.state.auditHistoryModal,
            };
        case actions.PRINCIPAL_SWAP_MODAL:
            return {
                ...state,
                principalSwapModal: action.state.principalSwapModal,
            };
        case actions.APPLICATION_FILES_MODAL:
            return {
                ...state,
                applicationFilesModal: action.state.applicationFilesModal,
            };
        default:
            return { ...state };
    }
};

export default applicationReducer;
